import { Colors } from '../common/Colors';

type viewHintListType = {
  [key: string]: {
    color: string;
    backgroundColor: string;
  };
};

export const helperViewHintList: viewHintListType = {
  success: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.success
  },
  warning: {
    color: Colors.text.buttonInverse,
    backgroundColor: Colors.ut.warning
  },
  error: {
    color: Colors.text.buttonDefault,
    backgroundColor: Colors.ut.error
  },
  'error-dim': {
    color: Colors.text.error,
    backgroundColor: Colors.ut.errorDim
  },
  danger: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.alert
  },
  info: {
    color: Colors.text.default,
    backgroundColor: Colors.ut.help
  },
  alert: {
    color: Colors.text.alert,
    backgroundColor: Colors.ut.alertDim
  },
  buy: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.primary
  },
  sell: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.alert
  }
};
